import { Box, Button, Grid, styled } from "@mui/material";
import { IOnboardStepProps } from "features/onboarding/types";
import Shopify_logo from "Assets/Images/ThirdParty/shopify_logo_black.png";
import Ecwid_logo from "Assets/Images/ThirdParty/Ecwid_LSLockup_BlackRGB_Ecwid_EN.svg";
import Code_icon from "Assets/Images/ThirdParty/code.png";
import Woo from "Assets/Images/ThirdParty/woocommerce-logo-color-black@2x.png";
import Wordpress_logo from "Assets/Images/ThirdParty/wordpress.png";
import Image from "mui-image";
import { useCallback, useEffect, useState } from "react";
import { saveProject } from "features/project";
import { useDispatch } from "react-redux";
import { updateProject } from "Actions";
import { ApiPlatform } from "@incendium/api";

const StyledPlatformButton = styled(Button)<{ active: boolean }>(
  ({ theme, active }) => ({
    background: active ? theme.palette.primary.main : "transparent",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    borderColor: theme.palette.secondary.main,
    boxShadow: "0 0 1px 1px #c8cbdd",
    gap: 12,
    color: active ? "white" : theme.palette.secondary.main,
    fontSize: 16,
  }),
);

function OnboardingPlatformSelection({ project }: IOnboardStepProps) {
  const dispatch = useDispatch();
  const [platform, setPlatform] = useState<ApiPlatform | string>(
    project.platform || "",
  );

  const onSubmit = useCallback(async () => {
    if (platform !== project?.platform && platform) {
      const res = await saveProject(project?.clientId as number, {
        ...project,
        platform: platform as ApiPlatform,
      });

      dispatch(updateProject(res));
    }
  }, [platform, dispatch, project]);

  useEffect(() => {
    // save on change
    onSubmit();
  }, [platform]);

  const onClick = useCallback((platform: ApiPlatform) => {
    setPlatform(platform);
  }, []);

  return (
    <Box display="flex" flexDirection="column" height="100%" py={8} px={6}>
      <Box sx={{ flex: 1 }}>
        <Grid container spacing={4} mb={5} alignItems="center">
          <Grid item xs={4}>
            <StyledPlatformButton
              fullWidth
              active={platform === ApiPlatform.PLATFORM_SHOPIFY}
              variant="outlined"
              onClick={() => onClick(ApiPlatform.PLATFORM_SHOPIFY)}
            >
              <Image
                height={40}
                src={Shopify_logo}
                duration={50}
                fit={"contain"}
              />
              Shopify
            </StyledPlatformButton>
          </Grid>
          <Grid item xs={4}>
            <StyledPlatformButton
              fullWidth
              active={platform === ApiPlatform.PLATFORM_ECWID}
              variant="outlined"
              onClick={() => onClick(ApiPlatform.PLATFORM_ECWID)}
            >
              <Image
                height={40}
                src={Ecwid_logo}
                duration={50}
                fit={"contain"}
              />
              Ecwid
            </StyledPlatformButton>
          </Grid>
          <Grid item xs={4}>
            <StyledPlatformButton
              fullWidth
              active={platform === ApiPlatform.PLATFORM_WOOCOMMERCE}
              variant="outlined"
              onClick={() => onClick(ApiPlatform.PLATFORM_WOOCOMMERCE)}
            >
              <Image height={40} src={Woo} duration={50} fit={"contain"} />
            </StyledPlatformButton>
          </Grid>
          <Grid item xs={4}>
            <StyledPlatformButton
              fullWidth
              active={platform === ApiPlatform.PLATFORM_WORDPRESS}
              variant="outlined"
              onClick={() => onClick(ApiPlatform.PLATFORM_WORDPRESS)}
            >
              <Image
                height={40}
                src={Wordpress_logo}
                duration={50}
                fit={"contain"}
              />
              Wordpress
            </StyledPlatformButton>
          </Grid>
          <Grid item xs={4}>
            <StyledPlatformButton
              fullWidth
              active={platform === ApiPlatform.PLATFORM_STANDARD}
              variant="outlined"
              onClick={() => onClick(ApiPlatform.PLATFORM_STANDARD)}
            >
              <Image
                height={40}
                src={Code_icon}
                duration={50}
                fit={"contain"}
              />
              Custom HTML
            </StyledPlatformButton>
          </Grid>
          <Grid item xs={4}>
            <StyledPlatformButton
              fullWidth
              active={platform === ApiPlatform.PLATFORM_SPA}
              variant="outlined"
              onClick={() => onClick(ApiPlatform.PLATFORM_SPA)}
            >
              <Image
                height={40}
                src={Code_icon}
                duration={50}
                fit={"contain"}
              />
              SPA
            </StyledPlatformButton>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default OnboardingPlatformSelection;
